// src/App.js

import "./App.css";
import { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

import Home from "./components/Home";
import CreateAccount from "./components/CreateAccount";
import RecoverAccount from "./components/RecoverAccount";
import WalletView from "./components/WalletView";
import WalletIcons from "./components/WalletIcons";
import SendPkrPage from "./pages/SendPkrPage"; // <-- ensure this file exists
import BuySell from "./components/BuySell";

import Receive from "./pages/Receive";
import Dashboard from "./pages/Dashboard";
import Explorer from "./pages/Explorer";
import Activity from "./pages/Activity";
import Settings from "./pages/Settings";

import ZakatClaim from "./pages/ZakatClaim";
import DonationSuccess from "./pages/DonationSuccess";

import BaitLogo from "./BaitLogo.png";
import Market from "./pages/Market";
import BackendTest from "./pages/BackendTest";
import SendBaitCash from "./pages/SendBaitCash";
import ConvertPage from "./pages/ConvertPage";
import ReceivePage from "./pages/ReceivePage";
import ZakatPage from "./pages/ZakatPage";
import DonatePage from "./pages/DonatePage";
import GovtPayPage from "./pages/GovtPayPage";
import WomenFundPage from "./pages/WomenFundPage";
import MarketplacePage from "./pages/MarketplacePage";
import Header from "./components/Header";





const CHAIN_LOGOS = {
  "0x777771": BaitLogo,
  "0x1": "https://cryptologos.cc/logos/ethereum-eth-logo.png",
  "0x89": "https://cryptologos.cc/logos/polygon-matic-logo.png",
};


function App() {

  const [wallet, setWallet] = useState(null);
  const [seedPhrase, setSeedPhrase] = useState(null);

  const [selectedChain, setSelectedChain] = useState("0x777771");

  const [nfts, setNfts] = useState(null);
  const [tokens, setTokens] = useState(null);
  const [balance, setBalance] = useState(0);

  const navigate = useNavigate();


  /*
  |--------------------------------------------------------------------------
  | LOGIN STATE
  |--------------------------------------------------------------------------
  */

  const isLoggedIn = Boolean(wallet && seedPhrase);


  /*
  |--------------------------------------------------------------------------
  | LOGOUT
  |--------------------------------------------------------------------------
  */

  const logout = () => {
    setSeedPhrase(null);
    setWallet(null);
    setNfts(null);
    setTokens(null);
    setBalance(0);
    navigate("/");
  };


  /*
  |--------------------------------------------------------------------------
  | SIDEBAR NAVIGATION
  |--------------------------------------------------------------------------
  */

  const handleSidebarNavigation = (action) => {
    console.log("Sidebar navigation:", action);

    switch (action) {
      case "dashboard":
        navigate("/dashboard");
        break;
      case "wallet":
        navigate("/yourwallet");
        break;
      case "market":
      case "markets":
        navigate("/market");
        break;
      case "swap":
        navigate("/swap");
        break;
      case "bridge":
        navigate("/bridge");
        break;
      case "transfer":
        navigate("/send");
        break;
      case "receive":
        navigate("/receive");
        break;
      case "buy":
        navigate("/buysell");
        break;
      case "activity":
        navigate("/activity");
        break;
      case "settings":
        navigate("/settings");
        break;
      default:
        console.warn("Unknown sidebar action:", action);
    }
  };


  /*
  |--------------------------------------------------------------------------
  | GLOBAL ROUTES (accessible even when not logged in)
  |--------------------------------------------------------------------------
  */

  if (
    window.location.pathname === "/backend-test" ||
    window.location.pathname === "/send-bait-cash"
  ) {
    return (
      <div className="app">
        {window.location.pathname === "/backend-test" ? (
          <BackendTest />
        ) : (
          <SendBaitCash wallet={wallet} selectedChain={selectedChain} />
        )}
      </div>
    );
  }

  /*
  |--------------------------------------------------------------------------
  | LOGGED-IN APPLICATION
  |--------------------------------------------------------------------------
  */

 if (isLoggedIn) {

  return (
    <div className="app">

      {/* =================================================
          GLOBAL WALLET HEADER
      ================================================= */}
      <Header
        selectedChain={selectedChain}
        setSelectedChain={setSelectedChain}
        logout={logout}
      />

      {/* =================================================
          GLOBAL SIDEBAR
      ================================================= */}
      <WalletIcons
        wallet={wallet}
        selectedChain={selectedChain}
        balance={balance}
        onNavigate={handleSidebarNavigation}
      />

      <Routes>

          {/* =================================================
              WALLET
          ================================================= */}
          <Route
            path="/yourwallet"
            element={
              <WalletView
                wallet={wallet}
                setWallet={setWallet}
                seedPhrase={seedPhrase}
                setSeedPhrase={setSeedPhrase}
                selectedChain={selectedChain}
                setSelectedChain={setSelectedChain}
                logout={logout}
                walletPage="main"
              />
            }
          />

          {/* =================================================
              SEND BAIT CASH (crypto)
          ================================================= */}
          <Route
            path="/send-bait-cash"
            element={
              <SendBaitCash
                wallet={wallet}
                selectedChain={selectedChain}
              />
            }
          />

          {/* =================================================
              SEND PKR (standalone page – reads state from location)
          ================================================= */}
          <Route
            path="/send-pkr"
            element={
              <SendPkrPage
                selectedChain={selectedChain}
                setSelectedChain={setSelectedChain}
              />
            }
          />
<Route
  path="/convert"
  element={
    <ConvertPage
      selectedChain={selectedChain}
      setSelectedChain={setSelectedChain}
    />
  }
/>
<Route
  path="/receive-pkr"
  element={
    <ReceivePage
      selectedChain={selectedChain}
      setSelectedChain={setSelectedChain}
    />
  }
/>
<Route
  path="/zakat"
  element={
    <ZakatPage
      selectedChain={selectedChain}
      setSelectedChain={setSelectedChain}
    />
  }
/>
<Route
  path="/donate"
  element={
    <DonatePage
      selectedChain={selectedChain}
      setSelectedChain={setSelectedChain}
    />
  }
/>
<Route
  path="/govt-pay"
  element={
    <GovtPayPage
      selectedChain={selectedChain}
      setSelectedChain={setSelectedChain}
    />
  }
/>
<Route
  path="/women-fund"
  element={
    <WomenFundPage
      selectedChain={selectedChain}
      setSelectedChain={setSelectedChain}
    />
  }
/>
<Route
  path="/marketplace"
  element={
    <MarketplacePage
      selectedChain={selectedChain}
      setSelectedChain={setSelectedChain}
    />
  }
/>
          {/* =================================================
              DASHBOARD
          ================================================= */}
          <Route
            path="/dashboard"
            element={
              <Dashboard
                wallet={wallet}
                seedPhrase={seedPhrase}
                selectedChain={selectedChain}
                setSelectedChain={setSelectedChain}
                // balance is not used by Dashboard
              />
            }
          />

          {/* =================================================
              MARKET
          ================================================= */}
          <Route path="/market" element={<Market />} />

          {/* =================================================
              SEND (crypto)
          ================================================= */}
          <Route
            path="/send"
            element={
              <WalletView
                wallet={wallet}
                setWallet={setWallet}
                seedPhrase={seedPhrase}
                setSeedPhrase={setSeedPhrase}
                selectedChain={selectedChain}
                setSelectedChain={setSelectedChain}
                logout={logout}
                walletPage="transfer"
              />
            }
          />

          {/* =================================================
              RECEIVE
          ================================================= */}
          <Route
            path="/receive"
            element={
              <Receive
                wallet={wallet}
                selectedChain={selectedChain}
                setSelectedChain={setSelectedChain}
                logout={logout}
              />
            }
          />

          {/* =================================================
              SWAP
          ================================================= */}
          <Route
            path="/swap"
            element={
              <WalletView
                wallet={wallet}
                setWallet={setWallet}
                seedPhrase={seedPhrase}
                setSeedPhrase={setSeedPhrase}
                selectedChain={selectedChain}
                setSelectedChain={setSelectedChain}
                logout={logout}
                walletPage="swap"
              />
            }
          />

          {/* =================================================
              BRIDGE
          ================================================= */}
          <Route
            path="/bridge"
            element={
              <WalletView
                wallet={wallet}
                setWallet={setWallet}
                seedPhrase={seedPhrase}
                setSeedPhrase={setSeedPhrase}
                selectedChain={selectedChain}
                setSelectedChain={setSelectedChain}
                logout={logout}
                walletPage="bridge"
              />
            }
          />

          {/* =================================================
              BUY / SELL
          ================================================= */}
          <Route path="/buysell" element={<BuySell />} />

          {/* =================================================
              ACTIVITY
          ================================================= */}
         <Route path="/activity" element={<Activity selectedChain={selectedChain} />} />

          {/* =================================================
              SETTINGS
          ================================================= */}
          <Route path="/settings" element={<Settings />} />

          {/* =================================================
              EXPLORER
          ================================================= */}
          <Route path="/explorer" element={<Explorer />} />

          {/* =================================================
              ZAKAT CLAIM
          ================================================= */}
          <Route path="/zakat-claim" element={<ZakatClaim />} />

          {/* =================================================
              DONATION SUCCESS
          ================================================= */}
          <Route path="/donation-success" element={<DonationSuccess />} />

          {/* =================================================
              LOGGED-IN FALLBACK
          ================================================= */}
          <Route
            path="*"
            element={
              <WalletView
                wallet={wallet}
                setWallet={setWallet}
                seedPhrase={seedPhrase}
                setSeedPhrase={setSeedPhrase}
                selectedChain={selectedChain}
                setSelectedChain={setSelectedChain}
                logout={logout}
                walletPage="main"
              />
            }
          />

        </Routes>

      </div>
    );
  }


  /*
  |--------------------------------------------------------------------------
  | LOGGED-OUT APPLICATION
  |--------------------------------------------------------------------------
  */

  return (
    <div className="app">

      <Routes>

        {/* HOME */}
        <Route path="/" element={<Home />} />

        {/* RECOVER */}
        <Route
          path="/recover"
          element={
            <RecoverAccount
              setSeedPhrase={setSeedPhrase}
              setWallet={setWallet}
            />
          }
        />

        {/* CREATE ACCOUNT */}
        <Route
          path="/yourwallet"
          element={
            <CreateAccount
              setSeedPhrase={setSeedPhrase}
              setWallet={setWallet}
            />
          }
        />

        {/* FALLBACK */}
        <Route path="*" element={<Home />} />

      </Routes>

    </div>
  );
}


export default App;